$ = require 'jquery'
Auth = require 'db/auth'
Board = require 'models/board'
CreateBoardComponent = require 'views/board-create/create-board-component'
Dialog = require 'views/lib/dialog'
GuidedTourState = require 'view-models/guided-tour-state'
React = require 'react'
t = require('views/internal/recup-with-helpers')('header_guided_tour')
trackUe = require 'debug/trackUe'
MemberState = require 'view-models/member-state'
Util = require 'lib/util'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: 'HeaderGuidedTour'

  constructor: (props) ->
    super(props)
    @banners = [
      require('images/tour/welcome.svg')
      require('images/tour/cards.svg')
      require('images/tour/cardback.svg')
      require('images/tour/lists.svg')
      require('images/tour/invite.svg')
      require('images/tour/done.svg')
    ]
    @headers = [
      'welcome-to-trello'
      'get-things-done-with-cards'
      'its-all-in-the-details'
      'get-organized'
      'invite-others'
      'youre-doing-great'
    ]
    @messages = [
      'trello-helps-you-collaborate-and-organize-everything-in-one-place'
      'cards-can-be-tasks-you-need-to-get-done-or-things-you-need-to-remember'
      'customize-cards-to-hold-useful-information'
      'use-lists-to-keep-track-of-the-status-of-tasks-or-organize-ideas-and-information'
      'trello-makes-it-easy-to-collaborate-with-others'
      'youve-got-the-basics-down'
    ]
    @state = {
      currentStep: GuidedTourState.getStep()
    }

  continueToStep: (currentStep) ->
    =>
      GuidedTourState.setStep(currentStep)
      if @state.isMounted
        @setState({ currentStep })

  startTour: ->
    GuidedTourState.startTour()

  newBoard: ->
    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultLists: true
        defaultOrg: @props.currentOrganization
        trackingOpts: { category: 'header', method: 'by clicking create board in header add menu' }

  hasCompletedTour: (currentStep) ->
    currentStep == GuidedTourState.COMPLETE

  onHideDialogTriggerClick: (e) ->
    Util.stop(e)
    @props.onDismiss()
    Dialog.hide()

  onSkipTriggerClick: (e) ->
    { currentStep } = @state
    { currentModel } = @props
    trackUe('guided tour', 'skipped', 'tour', '', '', '', { 'boardId': currentModel?.get('id'), currentStep })
    Auth.me().dismissGuidedTour()
    @onHideDialogTriggerClick(e)

  onSeeMoreTipsClick: (e) ->
    { currentModel, onShowTips } = @props
    trackUe('guided tour', 'showed', 'tips', '', '', '', { 'boardId': currentModel?.get('id') })
    @onHideDialogTriggerClick(e)
    onShowTips(e)

  setBoard: (currentModel) ->
    # If the user happens to land on another board that
    # doesn't have the minimum amount of structure for the tour (defaultLists),
    # but has already deleted the board that kicked off the tour, this
    # subsequent board won't be saved (thus prompting the user to go back there)
    # until it has the minimum amount of structure.
    if currentModel instanceof Board && currentModel?.id && currentModel?.listList.length > 1 && !currentModel?.isWelcomeBoard()
      GuidedTourState.setBoard(currentModel.id, currentModel.getUrl())

  showCardComposer: ->
    { currentStep } = @state
    { currentModel } = @props
    if currentStep == GuidedTourState.CARD
      firstList = currentModel?.listList?.first()
      if firstList?
        currentModel.composer.save({
          list: firstList
          index: firstList.openCards().length
          vis: true
        })

  renderProgressIndicator: (currentStep, targetStep) ->
    t.a '.guided-tour-progress-indicator',
      onClick: @continueToStep(targetStep).bind(@)
      class: t.classify({
        'guided-tour-progress-indicator-active': currentStep == targetStep || @hasCompletedTour(currentStep)
      }), ->
        if targetStep < currentStep
          t.icon 'check', { class: 'light' }

  render: t.renderable ->
    { currentStep } = @state
    { currentModel } = @props

    @setBoard(currentModel)

    onEditableBoardModel = (currentModel instanceof Board && currentModel?.editable() && GuidedTourState.isBoardForTour(currentModel?.id))
    modelId = currentModel?.get('id')

    trackUe('guided tour', 'opens', 'step', '', '', '', { modelId, currentStep })

    t.div '.guided-tour', =>
      t.div '.guided-tour-title', =>
        t.span ->
          t.format 'get-started'
        t.a '.dialog-close-button', {
          onClick: @onHideDialogTriggerClick.bind(@)
        }, =>
          t.icon 'close'
      if currentStep == GuidedTourState.WELCOME
        welcomeBanner =
          if onEditableBoardModel
            require('images/tour/welcome.svg')
          else
            require('images/tour/create.svg')

        t.img '.guided-tour-banner', { src: welcomeBanner }
        t.h3 -> t.format 'welcome-to-trello'
        t.p '.guided-tour-message', ->
          t.format 'trello-helps-you-collaborate-and-organize-everything-in-one-place'

        firstStepCallback = if onEditableBoardModel then @startTour.bind(@) else @newBoard.bind(@)
        firstStepCallToAction = if onEditableBoardModel then 'lets-do-this' else 'create-a-board'

        t.button '.button.primary.guided-tour-start', { onClick: firstStepCallback }, =>
          t.format firstStepCallToAction
        t.a '.guided-tour-skip', { onClick: @onSkipTriggerClick.bind(@) }, =>
          t.format 'skip-this'
      else
        inProgressOrFinished = onEditableBoardModel && !@hasCompletedTour(currentStep) || @hasCompletedTour(currentStep)
        previouslyStartedTour = currentModel instanceof Board && currentModel?.id && !GuidedTourState.isBoardForTour(currentModel?.id) && GuidedTourState.get('boardUrl')

        progressBanner = if inProgressOrFinished then @banners[currentStep] else require('images/tour/return.svg')
        progressCallToAction = if inProgressOrFinished then @headers[currentStep] else 'open-a-board'
        progressMessage =
          if inProgressOrFinished
            @messages[currentStep]
          else if previouslyStartedTour
            'click-here-to-go-back-to-your-board'
          else
            'click-boards-or-go-back-home'

        t.img '.guided-tour-banner', { src: progressBanner }
        t.div '.guided-tour-progress-indicators', =>
          [1..4].map (targetStep) => @renderProgressIndicator(currentStep, targetStep)
        t.h3 => t.format progressCallToAction
        t.p '.guided-tour-message', =>
          if previouslyStartedTour
            trackUe('guided tour', 'previously started', 'tour', '', '', '', { boardId: GuidedTourState.get('idBoard'), otherBoardId: modelId })
            t.a { href: GuidedTourState.get('boardUrl') }, ->
              t.format progressMessage
          else
            t.format progressMessage

        if !@hasCompletedTour(currentStep)
          t.a '.guided-tour-skip', { onClick: @onSkipTriggerClick.bind(@) }, =>
            t.format 'skip-this'
        else
          t.div '.guided-tour-buttons', =>
            t.button '.button.guided-tour-end', { onClick: @onSkipTriggerClick.bind(@) }, =>
              t.format 'im-done'
            t.button '.button.primary.guided-tour-tips', { onClick: @onSeeMoreTipsClick.bind(@) }, =>
              t.format 'see-more-tips'

    @showCardComposer()



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-guided-tour.coffee